import { Advisor } from '../../../interfaces/Advisors';
import { AdvisorDto } from '../../../interfaces/dtos/AdvisorsDto';
import { toTitleCase } from '../../../utils/toTitleCase';
import transformAgency from './transformAgency';
import transformPhones from './transformPhones';

export default function transformAdvisor(dto: AdvisorDto): Advisor {
  if (!dto) return undefined;
  return {
    agency: transformAgency(dto.agency),
    email: dto.email,
    fullName: toTitleCase(dto.fullName),
    id: dto.id,
    phones: transformPhones(dto.phones),
  };
}
